module.exports = __webpack_public_path__ + "assets/img/phone.ee6a9772.svg";